import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { NumberViewComponent } from './number-view.component';
import { InputContainerComponent } from '../input-container/input-container.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent],
    selector: 'wd-number-input',
    templateUrl: 'number-input.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/input.component.css'],
})
export class NumberInputComponent extends NumberViewComponent implements OnInit {
	@ViewChild('inputValue') inputValue!: NgModel;

	constructor() {
		super();
	}

	override onChange(changes?: SimpleChanges | undefined): void {
		if (this.model !== undefined && this.model !== null) {
			this.model = parseFloat(this.model.toString());
		}
		super.onChange(changes);
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}
}
